import { render, staticRenderFns } from "./ReservationColumnGroupInputForm.vue?vue&type=template&id=5ab77670&scoped=true&"
import script from "./ReservationColumnGroupInputForm.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnGroupInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnGroupInputForm.vue?vue&type=style&index=0&id=5ab77670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab77670",
  null
  
)

export default component.exports